import moment from "moment";

/** UTC calendar day of received + 10 days — matches apl-utility-service complaintSla + ComplaintsTable SLA chip */
export function defaultResponseDueYmdFromReceived(dateReceived) {
  if (!dateReceived) return "";
  const d = new Date(dateReceived);
  if (Number.isNaN(d.getTime())) return "";
  const utc = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  return moment.utc(utc + 10 * 86400000).format("YYYY-MM-DD");
}

/** Effective calendar due date for UI when API attached slaDueDateYmd vs legacy rows */
export function complaintRowDueYmd(row) {
  if (!row) return "";
  if (row.slaDueDateYmd) return row.slaDueDateYmd;
  if (row.responseDueDate) {
    const m = moment.utc(row.responseDueDate);
    return m.isValid() ? m.format("YYYY-MM-DD") : "";
  }
  return defaultResponseDueYmdFromReceived(row.dateReceived);
}
